import locationDistanceComponent from "./location_distance.component";
import locationDistanceAll from './all';
import locationDistanceCreate from './create';
import locationDistanceEdit from './edit';

let locationDistanceModule = angular.module('locationDistance', [
    locationDistanceAll,
    locationDistanceCreate,
    locationDistanceEdit
])

    .component('locationDistance', locationDistanceComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        $stateProvider
            .state('location_distance.all', {
                url: '/all/:page',
                component: 'locationDistanceAll',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_location_distance.view'
                },
            })

            .state('location_distance.create', {
                url: '/create',
                component: 'locationDistanceCreate',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_location_distance.create'
                },
            })

            .state('location_distance.edit', {
                url: '/edit/:id',
                component: 'locationDistanceEdit',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_location_distance.edit'
                },
            })
    })
    .name;

export default locationDistanceModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/index.js